import { useContext } from 'react';
import { UserRoleContext } from './UserRoleContext';

export const useUserRole = () => {
  const { userRole, setUserRole } = useContext(UserRoleContext);
  return { userRole, setUserRole };
};
